import { useSyncExternalStore } from 'react';

import { isOnline, subscribeToNetwork } from './network';

/**
 * Netwerkstatus van het apparaat. Offline is een normale toestand, geen fout:
 * de UI toont hem neutraal/amber, nooit rood.
 */
export function useOnlineStatus(): boolean {
    return useSyncExternalStore(
        (onStoreChange) => subscribeToNetwork(() => onStoreChange()),
        () => isOnline(),
        () => true,
    );
}
